var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { photo_categories, capitalize_and_format_name, property_type, page_type } = options; 
__p+='\n<div class="component_bm-carousel" id="photo-category-wrapper">\n  <div class="rdc-carousel">\n    <div class="owl-carousel">\n      ';
 photo_categories.forEach((photo_category) => { 
__p+='\n        <div class="listing-card-compact" data-category="'+
((__t=( photo_category.category ))==null?'':__t)+
'">\n          <a href="javascript:void(0)" class="bm-link-overlay" data-omtag="'+
((__t=(property_type))==null?'':__t)+
':'+
((__t=(page_type))==null?'':__t)+
':photo_gallery:'+
((__t=( photo_category.category ))==null?'':__t)+
'_hero" itemprop="url"></a>\n            <div class="aspect-content compact-card-image-wrapper">\n              <img data-src="'+
((__t=( photo_category.img_url.replace('w300_h300', 'w140_h80') ))==null?'':__t)+
'" class="compact-card-image" alt="Category Photo">\n                <div class="overlay-text">\n                  <div class="category-details">\n                    '+
((__t=( capitalize_and_format_name(photo_category.category) ))==null?'':__t)+
' ('+
((__t=( photo_category.number_of_photos ))==null?'':__t)+
')\n                  </div>\n                </div>\n            </div>\n        </div>\n      ';
 }) 
__p+='\n    </div>\n  </div>\n</div>';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/optimization/qv-category-photo-carousel.jst.ejs